export const camelize = (str) =>
  !!str ? str.replace(/\W+(.)/g, (match, chr) => chr.toUpperCase()) : "";

export const parseCurrency = (currency) => parseFloat(currency).toFixed(2);

export const trim = (str) => (!!str ? str.trim() : "");

export const arrayToList = (arr) =>
  arr.reduce(
    (acc, elem, i) =>
      acc
        ? arr.length - 1 == i
          ? `${acc} and ${elem}`
          : `${acc}, ${elem}`
        : elem,
    ""
  );
